var _excluded = ["items", "activeItem", "onActiveItemChange"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListViewList = function ListViewList(props) {
  var items = props.items,
    activeItem = props.activeItem,
    onActiveItemChange = props.onActiveItemChange,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var handleMouseOver = function handleMouseOver(id) {
    return function () {
      if (onActiveItemChange) {
        onActiveItemChange(id);
      }
    };
  };
  var getItemClassNames = function getItemClassNames(id) {
    var classNames = '';
    if (!_.isNil(activeItem) && activeItem === id) {
      classNames += ' active';
    }
    return classNames;
  };
  return /*#__PURE__*/_jsx(List, Object.assign({
    celled: true,
    relaxed: true
  }, rest, {
    children: _.map(items, function (_ref) {
      var identifiant = _ref.identifiant,
        key = _ref.key,
        title = _ref.title,
        subtitle = _ref.subtitle;
      return /*#__PURE__*/_jsxs(List.Item, {
        className: getItemClassNames(identifiant || key),
        onMouseOver: handleMouseOver(identifiant || key),
        children: [/*#__PURE__*/_jsx(List.Header, {
          children: title
        }), subtitle]
      }, "item" + (identifiant || key));
    })
  }));
};
ListViewList.handledProps = ["activeItem", "items", "onActiveItemChange"];
ListViewList.propTypes = {
  activeItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // Liste des items à afficher.
  items: PropTypes.arrayOf(PropTypes.shape({
    identifiant: PropTypes.number,
    key: PropTypes.string,
    title: PropTypes.node,
    subtitle: PropTypes.node
  })),
  onActiveItemChange: PropTypes.func
};
ListViewList.defaultProps = {
  activeItem: null,
  items: null,
  onActiveItemChange: null
};
export default ListViewList;